// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import { NormalUsage, NormalUsageT } from "./normal-usage";
import { ValuedUsage, ValuedUsageT } from "./valued-usage";

export enum UsageVariant {
  NONE = 0,
  NormalUsage = 1,
  ValuedUsage = 2,
}

export function unionToUsageVariant(
  type: UsageVariant,
  accessor: (obj: NormalUsage | ValuedUsage) => NormalUsage | ValuedUsage | null,
): NormalUsage | ValuedUsage | null {
  switch (UsageVariant[type]) {
    case "NONE":
      return null;
    case "NormalUsage":
      return accessor(new NormalUsage())! as NormalUsage;
    case "ValuedUsage":
      return accessor(new ValuedUsage())! as ValuedUsage;
    default:
      return null;
  }
}

export function unionListToUsageVariant(
  type: UsageVariant,
  accessor: (index: number, obj: NormalUsage | ValuedUsage) => NormalUsage | ValuedUsage | null,
  index: number,
): NormalUsage | ValuedUsage | null {
  switch (UsageVariant[type]) {
    case "NONE":
      return null;
    case "NormalUsage":
      return accessor(index, new NormalUsage())! as NormalUsage;
    case "ValuedUsage":
      return accessor(index, new ValuedUsage())! as ValuedUsage;
    default:
      return null;
  }
}

export type UsageVariantT =
  | { type: "NONE"; value: null }
  | { type: "NormalUsage"; value: NormalUsageT }
  | { type: "ValuedUsage"; value: ValuedUsageT };
